/* eslint-disable */

import { isLocalEnvironment } from "../../services/environment";

export enum RaindropCardStyle {
  Basic = "basic",
  Warning = "warning",
  Gradient = "gradient",
  GradientPink = "gradient-pink",
}

const RaindropCard = ({
  colorBorderAccent = "",
  children,
  additionalClasses = "",
  onClick = () => {},
  isForcedLight = false,
  style = RaindropCardStyle.Basic,
  isDebug = false,
  isSelected = false,
  isBordered = false,
}) => {
  let border = `border-2 dark:border-color-dark-background-secondary dark:shadow-none shadow-sm shadow-slate-200 `;

  let background =
    "bg-color-background-secondary dark:bg-color-dark-background-secondary";

  let tailwindRounded = "rounded-xl";

  if (isForcedLight) {
    background = "bg-color-background-secondary";
  }

  if (colorBorderAccent) {
    border = `${border} border-l-[6px] ${colorBorderAccent} `;
  }

  if (isBordered) {
    border = `border-4 dark:border-color-dark-border-primary border-color-border-primary`;
  }

  if (style === RaindropCardStyle.Gradient) {
    background = "bg-gradient-to-br from-blue-800 to-purple-300";
  }
  if (style === RaindropCardStyle.GradientPink) {
    background = "bg-gradient-to-br from-pink-500 to-purple-500";
  }

  if (style == RaindropCardStyle.Warning) {
    background = "bg-blue-100 dark:bg-blue-800";
    border = "border border-blue-800 dark:border-blue-100";
  }

  if (isDebug && isLocalEnvironment()) {
    background = "bg-color-debug-green";
  }

  if (isSelected) {
    border = `border-2 border-color-raindrop-primary dark:border-color-raindrop-primary`;
  }

  return (
    <div
      className={`flex flex-col items-center  justify-center gap-2 p-4 text-center transition-all  w-full ${border}  ${background} ${additionalClasses} ${tailwindRounded} `}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default RaindropCard;
